import React, { useState, useEffect } from "react";
import { Modal, Input } from "antd";
import { FieldEditorProps } from "../../../types/common";
import ReactQuill from "react-quill";
import { COMPONENT_TYPE } from "../../../utils/FormMapper/XMLInputType";

interface ComponentsPropertiesProps extends FieldEditorProps {}

const { TextArea } = Input;

export const QAModalEditField: React.FC<ComponentsPropertiesProps> = ({
    onChange,
    onCloseEditor,
    value,
    disabled,
    componentsProperties,
}) => {
    const name = componentsProperties?.name ?? "";

    const [text, setText] = useState("");

    useEffect(() => {
        if (value) {
            setText(value);
        } else {
            setText("");
        }
    }, [value]);

    const modalWidth = componentsProperties?.type === COMPONENT_TYPE.INPUT_RICH_TEXT ? {width : '1080px'} : {}

    return (
        <Modal
            title={`Editar ${name}`}
            visible={onChange !== undefined}
            destroyOnClose
            {...modalWidth}
            onOk={() => {
                if (onChange !== undefined) {
                    onChange(text);
                }
                setText("");
                onCloseEditor();
            }}
            okButtonProps={{
                disabled: disabled,
            }}
            onCancel={onCloseEditor}
        >
            {componentsProperties?.type === COMPONENT_TYPE.INPUT_RICH_TEXT ? (
                <ReactQuill
                    theme="snow"
                    readOnly={disabled}
                    modules={{
                        toolbar: [
                            [{ header: [1, 2, 3, false] }],
                            ["bold", "italic", "underline", "strike", "blockquote"],
                            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                            ["link"],
                            ["clean"],
                        ],
                    }}
                    value={text}
                    onChange={(value) => {
                        setText(value);
                    }}
                    onBlur={(_pre, _sour, edit) => {
                        setText(edit.getHTML());
                    }}
                    style={{ minHeight: "500px", width: "100%" }}

                />
            ) : (
                <TextArea
                    onChange={(e) => setText(e.target.value)}
                    autoSize={{ minRows: 10, maxRows: 10 }}
                    style={{ width: "100%" }}
                    disabled={disabled || false}
                    value={text}
                    allowClear
                />
            )}
        </Modal>
    );
};
